<template>
  <div>
    <v-sheet color="primary" class="d-flex align-center" height="64px">
      <v-container class="d-flex justify-space-between py-0">
        <div>
          <v-btn
            color="white"
            v-if="informationsContacts.emergency_tel"
            :href="getTelLinkFromPhone(informationsContacts.emergency_tel)"
            depressed
            rounded
            class="
              primary--text
              text-body-1 text-none
              font-weight-bold
              px-md-7 px-lg-8
            "
          >
            <img
              src="/img/icons/emergency-icon.svg?v=2"
              class="d-block"
              height="26px"
            />
            <span class="ml-2">Emergência</span>
          </v-btn>

          <v-btn
            color="white"
            v-if="informationsContacts.ombudsman"
            :href="informationsContacts.ombudsman"
            target="_blank"
            depressed
            rounded
            class="
              primary--text
              text-body-1 text-none
              font-weight-bold
              px-md-7 px-lg-8
            "
            :class="{ 'ml-2': informationsContacts.emergency_tel }"
          >
            <v-icon size="20"> far fa-comment-dots </v-icon>
            <span class="ml-2">Ouvidoria</span>
          </v-btn>
        </div>

        <div class="d-flex">
          <v-btn
            color="transparent"
            href="https://orcamentos.hospitaldoispinheiros.com.br/formularios/site-AttLT3/paciente"
            target="_blank"
            depressed
            rounded
            class="
              white--text
              text-body-1 text-none
              font-weight-bold
              px-md-7 px-lg-4
            "
          >
            <span>Solicitar Orçamentos</span>
          </v-btn>
          <v-btn
            color="transparent"
            href="https://wa.me/5566999940069"
            target="_blank"
            depressed
            rounded
            class="
              white--text
              text-body-1 text-none
              font-weight-bold
              px-md-7 px-lg-4
            "
          >
            <span>Trabalhe Conosco</span>
          </v-btn>

          <v-btn
            color="transparent"
            href="https://exames.hospitaldoispinheiros.com.br:8443/Mediweb/login"
            target="_blank"
            depressed
            rounded
            class="
              white--text
              text-body-1 text-none
              font-weight-bold
              px-md-7 px-lg-4
            "
          >
            <v-icon size="20"> fa-stethoscope </v-icon>
            <span class="ml-2">Resultado de Exames</span>
          </v-btn>
        </div>
      </v-container>
    </v-sheet>

    <v-app-bar flat color="white" height="90px">
      <v-container class="py-0">
        <v-sheet
          width="100%"
          height="100%"
          color="transparent"
          class="d-flex justify-space-between align-center"
        >
          <router-link to="/">
            <img
              v-if="informations.img"
              :src="files + informations.img"
              :alt="informations.name"
              class="d-block"
              height="58px"
            />
          </router-link>

          <div class="d-flex align-center">
            <div>
              <div
                v-for="({ text, to, submenu }, key) in menu"
                :key="key"
                class="d-inline-flex"
              >
                <v-btn
                  class="
                    grey--text
                    text-caption text-lg-body-1 text-none
                    font-weight-medium
                    px-2 px-lg-3
                    py-5
                    nav-link
                  "
                  :to="to"
                  active-class="nav-link-active"
                  tile
                  depressed
                  text
                  v-if="!submenu"
                >
                  {{ text }}
                </v-btn>

                <v-menu v-else offset-y tile>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="
                        text-caption text-lg-body-1 text-none
                        font-weight-medium
                        px-2 px-lg-3
                        py-5
                      "
                      active-class="nav-link-active"
                      tile
                      depressed
                      text
                    >
                      {{ text }}
                      <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list tile>
                    <v-list-item
                      v-for="(item, index) in submenu"
                      :to="item.to"
                      :key="index"
                    >
                      <v-list-item-title class="grey--text text--darken-3">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <Search />
          </div>
        </v-sheet>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import { getTelLinkFromPhone } from "../../../utils/getTelLinkFromPhone";
import Search from "../../widgets/Search.vue";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    informationsContacts() {
      return this.$rest("informations-contacts").item;
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
  components: {
    Search,
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  border-bottom: 2px solid transparent;
  color: var(--v-grey-darken3);
  position: relative;
  transition: all 0.1s linear;
  &:before {
    opacity: 0 !important;
  }
  &.nav-link-active {
    color: var(--v-primary-base) !important;
  }
}
</style>
